// src/constants.ts
const env = typeof import.meta !== "undefined" ? import.meta.env : {};

export const wsBaseUrl = env.VITE_APP_WS_BASE_URL || "ws://localhost:8000/ws";
export const apiBaseUrl =
  env.VITE_APP_API_BASE_URL || "http://localhost:8000/api";
export const MIXPANEL_TOKEN = env.VITE_APP_MIXPANEL_TOKEN || "";
export const bucketName = env.VITE_APP_REPORT_IMAGE_BUCKET_NAME || "";
export const mapboxgl_accessToken = env.VITE_APP_MAPBOX_TOKEN || "";
export const ldClientSideID = env.VITE_LD_CLIENT_ID || "";
export const appMode = env.VITE_APP_MODE || "dev";
export const sentryDsn = env.VITE_SENTRY_DSN || "";
export const googleApiKey = env.VITE_GOOGLE_API_KEY || "";
export const googleAppId = env.VITE_GOOGLE_APP_ID || "";
export const microsoftClientId = env.VITE_MICROSOFT_CLIENT_ID || "";
